<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 3485 3485"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_652013856">
   <g>
    <path class="fil0"
          d="M1127 0c-862,0 -1127,748 -1127,1118 0,369 170,653 303,795 133,142 227,171 265,454 38,285 246,285 246,285l285 0 56 0 285 0c0,0 208,0 246,-285 37,-283 132,-312 265,-454 132,-142 303,-426 303,-795 0,-370 -266,-1118 -1127,-1118z" />
   </g>
    <g>
    <path class="fil0"
          d="M1411 2888l-284 0 -9 0 -285 0c0,0 -199,0 -199,143 0,142 48,255 114,255 66,0 133,199 133,199l237 0 9 0 237 0c0,0 66,-199 132,-199 66,0 114,-113 114,-255 0,-143 -199,-143 -199,-143z" />
   </g>
  </g>
 </g>
    <g id="Vrstva_x0020_1_0">
  <path class="fil1"
        d="M325 1392l0 -456 157 0c35,0 62,2 81,7 26,6 48,17 67,32 24,21 42,47 54,78 12,32 18,68 18,109 0,34 -5,65 -13,92 -8,26 -18,49 -31,66 -12,18 -26,31 -41,41 -15,11 -33,18 -55,23 -21,6 -45,8 -73,8l-164 0zm60 -53l97 0c30,0 54,-3 71,-9 17,-5 31,-13 41,-23 14,-15 25,-34 33,-58 8,-24 12,-54 12,-88 0,-48 -8,-85 -23,-110 -16,-26 -35,-43 -57,-52 -16,-6 -42,-9 -78,-9l-96 0 0 349z" />
      <polygon id="1" class="fil1" points="795,1392 795,936 855,936 855,1392 " />
      <path id="2" class="fil1"
            d="M960 1392l0 -456 90 0 108 323c10,30 17,52 22,67 5,-16 13,-41 24,-73l110 -317 81 0 0 456 -58 0 0 -381 -133 381 -54 0 -132 -388 0 388 -58 0z" />
      <path id="3" class="fil1"
            d="M1490 1392l0 -456 91 0 108 323c10,30 17,52 21,67 6,-16 14,-41 25,-73l110 -317 80 0 0 456 -58 0 0 -381 -133 381 -54 0 -132 -388 0 388 -58 0z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'DimmLight',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE;
  fill-rule: nonzero
}

.fil0 {
  fill: #CCCCCC;
  fill-rule: nonzero
}
</style>
